import { Listbox } from '@headlessui/react';
import { ReactComponent as ChevronDownIcon } from 'assets/icons/chevron-down.svg';
import { HOUR_TYPE } from 'utils/constants';

export const HOUR_TYPE_OPTIONS = [
  { label: 'All Hours', value: HOUR_TYPE.ALL },
  { label: 'Out of Working Hours', value: HOUR_TYPE.OUT_OF_WORKING_HOUR },
  { label: 'During Working Hours', value: HOUR_TYPE.DURING_WORKING_HOUR },
];

export type HourTypeOption = (typeof HOUR_TYPE_OPTIONS)[number];

interface HourTypeDropdownProps {
  value: HourTypeOption;
  onChange: (option: HourTypeOption) => void;
}

const HourTypeDropdown = ({ value, onChange }: HourTypeDropdownProps) => (
  <Listbox value={value} onChange={onChange}>
    {({ open }) => (
      <div className="relative w-[20rem]">
        <Listbox.Button
          className={`w-full flex items-center justify-between gap-x-0.8 rounded-[1rem] border shadow-primary py-1.3 px-1.6 max-h-[4.8rem] text-12 cursor-pointer outline-none hover:border-magenta ${
            open ? 'border-magenta' : 'border-lightest-grey'
          }`}
        >
          <span>{value.label}</span>
          <ChevronDownIcon className="w-1.4 h-1.4 shrink-0" />
        </Listbox.Button>
        {open && (
          <Listbox.Options className="absolute right-0 mt-0.5 w-full bg-white rounded-[1rem] shadow-primary z-10 py-1.5 flex flex-col gap-y-1.5 outline-none max-h-[20rem] overflow-y-auto">
            {HOUR_TYPE_OPTIONS.map((option) => (
              <Listbox.Option
                key={option.value}
                value={option}
                className={({ active, selected }) =>
                  `cursor-pointer pl-1.6 pr-2.4 ${
                    active || selected ? 'text-magenta' : ''
                  }`
                }
              >
                {option.label}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        )}
      </div>
    )}
  </Listbox>
);

export default HourTypeDropdown;
